import { useContext } from "react"
import { MessageGroup } from "@/reducers/messagesSlice"
import { ChatHistoryContext } from "@/contexts/ChatHistoryContext"

const useGroupedMessageActions = (messageGroup: MessageGroup) => {
  const { enterForwardingMode } = useContext(ChatHistoryContext)

  const handleForward = () => {
    // Extract all message IDs from the group and pass as array
    const messageIds = messageGroup.messages.map((m) => m.id)
    enterForwardingMode(messageIds)
  }

  return {
    handleForward,
  }
}

export default useGroupedMessageActions
